export const faqItems = [
    {
        id: "audience",
        questionKey: "main.landing.faq.items.audience.question",
        answerKey: "main.landing.faq.items.audience.answer",
    },
    {
        id: "trial-start",
        questionKey: "main.landing.faq.items.trialStart.question",
        answerKey: "main.landing.faq.items.trialStart.answer",
    },
    {
        id: "trial-features",
        questionKey: "main.landing.faq.items.trialFeatures.question",
        answerKey: "main.landing.faq.items.trialFeatures.answer",
    },
    {
        id: "documents",
        questionKey: "main.landing.faq.items.documents.question",
        answerKey: "main.landing.faq.items.documents.answer",
    },
    {
        id: "addons",
        questionKey: "main.landing.faq.items.addons.question",
        answerKey: "main.landing.faq.items.addons.answer",
    },
];
